module.exports = __webpack_public_path__ + "img/BOOK1.36835ee2.png";